"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Box_1 = require("@mui/material/Box");
var Document_1 = require("./Document");
var List_1 = require("@mui/material/List");
var Fab_1 = require("@mui/material/Fab");
var Add_1 = require("@mui/icons-material/Add");
var DocumentModal_1 = require("./DocumentModal");
var Document_2 = require("../models/Document");
var DocumentService_1 = require("../services/DocumentService");
var Role_1 = require("../shared/utilities/Role");
var material_1 = require("@mui/material");
var Toast_1 = require("../shared/utilities/Toast");
var DrawerHeader = styles_1.styled("div")(function (_a) {
    var theme = _a.theme;
    return (__assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: theme.spacing(0, 1) }, theme.mixins.toolbar));
});
function Documents(props) {
    var role = Role_1.default();
    var _a = Toast_1.default(), showErrorMessage = _a.showErrorMessage, showSuccessMessage = _a.showSuccessMessage;
    var _b = React.useState(false), ready = _b[0], setReady = _b[1];
    var modalRef = React.useRef(null);
    var _c = React.useState([]), documents = _c[0], setDocuments = _c[1];
    var _d = React.useState(3), maxId = _d[0], setMaxId = _d[1];
    var openDocumentModal = function (document) {
        var _a, _b;
        if (document == null || document.DocumentId == '') {
            var newDocument = new Document_2.DocumentModel();
            modalRef && ((_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _a === void 0 ? void 0 : _a.handleOpen(newDocument));
        }
        else {
            modalRef && ((_b = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _b === void 0 ? void 0 : _b.handleOpen(document));
        }
    };
    var deleteDocument = function (id) {
        setReady(false);
        var document = documents.filter(function (document) { return document.DocumentId == id; })[0];
        DocumentService_1.default.UpdateDocument(document.DocumentId, document.Name, document.Description, null, null, true, document.DisplaySequence == '' ? null : document.DisplaySequence).then(function (response) {
            if (response != null && response.Document != null) {
                var newSetDocuments = __spreadArray([], documents);
                var index = newSetDocuments.map(function (document) { return document.DocumentId; }).indexOf(id);
                newSetDocuments.splice(index, 1);
                setDocuments(__spreadArray([], newSetDocuments));
                showSuccessMessage('Document deleted successfully!');
            }
            else {
                showErrorMessage('Unknown error occured deleting document!');
            }
            setReady(true);
        });
    };
    var upsertDocument = function (document, documentBytes, documentName) {
        setReady(false);
        if (document.DocumentId == null || document.DocumentId == '') {
            DocumentService_1.default.CreateDocument(document.Name, document.Description, documentName, documentBytes, props.type == "Maps" ? 1 : 2, document.DisplaySequence == '' ? null : document.DisplaySequence).then(function (response) {
                if (response != null && response.Document != null) {
                    var newSetDocuments = documents;
                    console.log('response', response);
                    newSetDocuments.push(response.Document);
                    newSetDocuments.sort(function (a, b) {
                        return a.DisplaySequence - b.DisplaySequence;
                    });
                    setDocuments(__spreadArray([], newSetDocuments));
                    showSuccessMessage('Document added successfully!');
                }
                else {
                    showErrorMessage('Unknown error occured adding document!');
                }
                setReady(true);
            });
        }
        else {
            DocumentService_1.default.UpdateDocument(document.DocumentId, document.Name, document.Description, documentName, documentBytes, false, document.DisplaySequence == '' ? null : document.DisplaySequence).then(function (response) {
                if (response != null && response.Document != null) {
                    var newSetDocuments = __spreadArray([], documents);
                    var index = newSetDocuments.map(function (document) { return document.DocumentId; }).indexOf(response.Document.DocumentId);
                    console.log('index found', index);
                    var item = __assign(__assign({}, documents[index]), { Name: response.Document.Name, Description: response.Document.Description, DocumentLocation: response.Document.DocumentLocation, DisplaySequence: response.Document.DisplaySequence });
                    console.log('response document', response.Document);
                    newSetDocuments[index] = item;
                    newSetDocuments.sort(function (a, b) {
                        return a.DisplaySequence - b.DisplaySequence;
                    });
                    setDocuments(__spreadArray([], newSetDocuments));
                    console.log(newSetDocuments);
                    showSuccessMessage('Document updated successfully!');
                }
                else {
                    showErrorMessage('Unknown error occured updating document!');
                }
                setReady(true);
            });
        }
    };
    React.useEffect(function () {
        console.log('effect used');
        DocumentService_1.default.GetDocuments(props.type == "Maps" ? 1 : 2).then(function (response) {
            if (response != null && response.Documents != null) {
                console.log('found documents', response.Documents);
                setDocuments(response.Documents);
                setReady(true);
            }
            else {
                showErrorMessage('Unknown error occured getting documents!');
            }
        });
    }, []);
    return (React.createElement(Box_1.default, { component: "main", sx: { flexGrow: 1, p: 3, marginBottom: '40px' } },
        React.createElement(DrawerHeader, null),
        !ready &&
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                React.createElement(material_1.CircularProgress, { size: 100, disableShrink: true })),
        ready &&
            React.createElement(React.Fragment, null,
                React.createElement(List_1.default, { sx: { width: '100%', bgcolor: 'background.paper' } }, documents.map(function (document) { return (React.createElement(Document_1.default, { id: document.DocumentId, name: document.Name, description: document.Description, documentLocation: document.DocumentLocation, openDocumentModal: openDocumentModal, displaySequence: document.DisplaySequence, delete: deleteDocument })); })),
                role === 'Admin' &&
                    React.createElement(Fab_1.default, { color: "primary", style: { float: 'right' }, variant: "extended", onClick: function () {
                            openDocumentModal(new Document_2.DocumentModel());
                        } },
                        React.createElement(Add_1.default, null),
                        " Add New Document")),
        React.createElement(DocumentModal_1.default, { ref: modalRef, upsertDocument: upsertDocument })));
}
exports.default = Documents;
//# sourceMappingURL=Documents.js.map